import { Box, SvgIconProps, useTheme } from "@mui/material";

const LockIcon = ({
  color = "primary",
  height = 20,
  width = 20,
  customColor,
  disableDimentions = false,
  sx = {},
}: SvgIconProps & {
  customColor?: string;
  disableDimentions?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        ...(!disableDimentions
          ? {
              display: "flex",
              alignItems: "center",
              height: height,
              width: width,
            }
          : {}),
        ...sx,
      }}
    >
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0909 14.6882V16.501M7.54545 8.81818V6.18137C7.54545 3.89194 9.58255 2 12.0476 2C14.5127 2 16.5498 3.89194 16.5498 6.18137V8.81818M21.1818 20V11.2727C21.1818 10.1682 20.2864 9.27273 19.1818 9.27273L5 9.27273C3.89543 9.27273 3 10.1682 3 11.2727L3 20C3 21.1046 3.89543 22 5 22H19.1818C20.2864 22 21.1818 21.1046 21.1818 20Z"
          stroke="#657482"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

export default LockIcon;
